module.exports = "mutation DeleteContactShare($id: ID!) {\n  deleteContactShare(id: $id) {\n    deleted\n  }\n}\n"